
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"},style,staticStyle],
              attrs: Object.assign({"width":"20px","height":"12px","viewBox":"0 0 20 12","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/","style":"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"white","fill-rule":"nonzero"},attrs:{"d":"M18.586,12L1.444,12L10.015,0.929L18.586,12Z"}})])
          )
        }
      }
    